// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { GetNewsListApiParameter, NewsListApiResult, NewsListCollectionApiResult } from "@guestsupply/App/Services/NewsListService";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { DataViewState, setDataViewLoaded, setDataViewLoading } from "@insite/client-framework/Store/Data/DataState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export interface NewsListState extends DataViewState<NewsListApiResult> {
    parameter?: GetNewsListApiParameter;
    newsList?: NewsListCollectionApiResult;
}

const initialState: NewsListState = {
    parameter: {},
    isLoading: {},
    byId: {},
    dataViews: {},
};

const reducer = {
    "xNewsList/BeginLoadLists": (draft: Draft<NewsListState>, action: { parameter: GetNewsListApiParameter }) => {
        setDataViewLoading(draft, action.parameter);
    },
    "xNewsList/CompleteLoadLists": (
        draft: Draft<NewsListState>,
        action: { parameter: GetNewsListApiParameter; collection: NewsListCollectionApiResult },
    ) => {
        const collection = {
            ...action.collection,
            pagination: action.collection.paginationModel,
            properties: {
                ...action.collection.properties,
                categories: action.collection.categoryCounts,
            }
        }
        setDataViewLoaded(
            draft,
            action.parameter,
            collection,
            collection => collection.newsListings,
        );
    },
    "xNewsList/UpdateParameter": (draft: Draft<NewsListState>, action: { parameter: GetNewsListApiParameter }) => {
        draft.parameter = { ...draft.parameter, ...action.parameter };

        for (const key in draft.parameter) {
            const value = (<any>draft.parameter)[key];

            // remove empty parameters
            if (value === "" || value === undefined) {
                delete (<any>draft.parameter)[key];
            }
        }
    },
};

const xNewsList = createTypedReducerWithImmer(initialState, reducer);

(reducers as any).xNewsList = xNewsList;

export type xNewsList = {
    xNewsList: NewsListState;
} & ApplicationState;

type NewsListReducer = {
    [key: string]: typeof xNewsList;
};

export type NewsListActions = Parameters<NewsListReducer[keyof NewsListReducer]>[1] | AnyAction;
